import { Box, BoxProps } from '@mui/material'
import React from 'react'
interface Props extends BoxProps {
  children: any
  firstStepValue?: number
  currentCounter?: number
}

const TimelineFormWrapper: ReactFC<Props> = ({
  children,
  firstStepValue = 1,
  sx,
  ...restParams
}) => {
  let stepsCounter = firstStepValue - 1

  const mapChildren = (children:any):React.ReactNode => {
    return React.Children.map(children, child => {
      if (!React.isValidElement(child)) return child
      if (child.type === React.Fragment) return mapChildren((child.props as any).children)
      stepsCounter++
      return React.cloneElement(child, {
        ...child.props as any, step: stepsCounter
      })
    })
  }

  return (
    <Box
      sx={{
        margin: '2rem 4rem', ...sx
      }}
      {...restParams}
    >
      {/* <Wrapper firstStepValue={firstStepValue}>{children}</Wrapper> */}
      {mapChildren(children)}
    </Box>
  )
}
export default TimelineFormWrapper
